import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root' // Questo garantisce che il servizio sia singleton
})
export class BackdropService {
    // Uso i signals di Angular per gestire lo stato reattivo
    private isActiveSignal = signal(false);
    private loadingTextSignal = signal('');
    private loadingSpinnerSignal = signal(false);
    private router = inject(Router);

    // Espongo i signals come readonly per evitare modifiche esterne
    readonly isActive = this.isActiveSignal.asReadonly();
    readonly loadingText = this.loadingTextSignal.asReadonly();
    readonly loadingSpinner = this.loadingSpinnerSignal.asReadonly();

    constructor() { // Ascolta gli eventi di navigazione: quando la navigazione termina con successo, chiude la backdrop
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.hide();
        });

    }

    /**
     * Mostra il backdrop con un testo opzionale
     */
    show(text: string = '', spinON: boolean = false): void {
        this.loadingTextSignal.set(text);
        this.loadingSpinnerSignal.set(spinON);
        this.isActiveSignal.set(true);
    }

    /**
     * Nasconde il backdrop
     */
    hide(): void {
        this.isActiveSignal.set(false);
        this.loadingTextSignal.set('');
    }

    /**
     * Toggle del backdrop
     */
    toggle(): void {
        this.isActiveSignal.update(value => !value);
    }

    /**
     * Aggiorna il testo del backdrop senza cambiare lo stato di visibilità
     */
    updateText(text: string): void {
        this.loadingTextSignal.set(text);
    }
}